declare const APP_VERSION: string;
declare const SOURCE_VERSION: string;

export function getBuildVersion(): string {
	return `${APP_VERSION}-${SOURCE_VERSION}`;
}
